var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter filter-choice"},[_c('multiselect',{attrs:{"options":_vm.options,"multiple":true,"placeholder":"Оберіть зі списку","noOptions":"Список пустий","selectLabel":"✓","selectedLabel":"","deselectLabel":"✕"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }